import { render, staticRenderFns } from "./ClientContactList.vue?vue&type=template&id=6cbbfaea&"
import script from "./ClientContactList.vue?vue&type=script&lang=js&"
export * from "./ClientContactList.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactList.vue?vue&type=style&index=0&id=6cbbfaea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports